import React, { Fragment } from 'react';

import {
    Section,
    Typography,
    MarkdownContent,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { range } from 'wanderu-utils';

import styles from './Wanderu101Content.scss';

const NUM_OF_CONTENT = 4;

function Wanderu101Content(props) {
    const {
        t,
    } = props;

    return (
        <Section>
            {range(NUM_OF_CONTENT).map((index) => (
                <Fragment key={`content-${index}`}>
                    <Typography
                        className={styles.title}
                        variant="h3"
                    >
                        {t(`homepage-about-title-${index + 1}`)}
                    </Typography>
                    <MarkdownContent className={styles.description}>
                        {t(`homepage-about-description-${index + 1}`)}
                    </MarkdownContent>
                </Fragment>
            ))}
        </Section>
    );
}

export { Wanderu101Content };
export default localize(Wanderu101Content, ['t'], 'baseApp');
